const ROLE_LEVELS = {
  any: 0,
  schedule: 1,
  admin: 10,
}

const isAdmin = (user) => user.meta.admin ? true : false

const hasRole = (userRole, requiredRole) => ROLE_LEVELS[userRole] >= ROLE_LEVELS[requiredRole]

module.exports = {
  ROLE_LEVELS,
  isAdmin,
  hasRole,
}